import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMetadata, getStructuredData } from '../data/seo';

export default function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = getMetadata(pathname);
    document.title = meta.title;
    const setTag = (selector, tag, attributes) => {
      const element = document.head.querySelector(selector) || document.createElement(tag);
      Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
      if (!element.parentNode) document.head.appendChild(element);
    };
    setTag('meta[name="description"]', 'meta', { name: 'description', content: meta.description });
    setTag('meta[name="robots"]', 'meta', { name: 'robots', content: meta.robots });
    setTag('link[rel="canonical"]', 'link', { rel: 'canonical', href: meta.canonical });
    Object.entries({ title: meta.title, description: meta.description, url: meta.canonical, type: meta.type, site_name: 'Angelo Ruiz' }).forEach(([key, value]) => setTag(`meta[property="og:${key}"]`, 'meta', { property: `og:${key}`, content: value }));
    document.getElementById('person-schema')?.remove();
    const schema = getStructuredData(pathname);
    if (schema) {
      const script = document.createElement('script');
      script.id = 'person-schema';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, [pathname]);
  return null;
}
